module.exports = __webpack_public_path__ + "img/4.0d2eb12b.png";